import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "supply-type",
  "use": "supply-type-usage",
  "viewBox": "0 0 19.5 12.98",
  "content": "<symbol viewBox=\"0 0 19.5 12.98\" id=\"supply-type\"><g class=\"b\"><path d=\"M.46 5.89h1a.46.46 0 0 0 .46-.46V5h15.67v.43a.45.45 0 0 0 .46.46h1a.46.46 0 0 0 .46-.46v-5A.47.47 0 0 0 19 0h-1a.46.46 0 0 0-.46.46v.43H1.91V.46A.47.47 0 0 0 1.45 0h-1A.47.47 0 0 0 0 .46v5a.46.46 0 0 0 .46.46M.46 13h1a.47.47 0 0 0 .46-.46v-.43h15.67v.43a.46.46 0 0 0 .46.46h1a.47.47 0 0 0 .46-.46v-5a.46.46 0 0 0-.51-.45h-1a.45.45 0 0 0-.46.45V8H1.91v-.46a.46.46 0 0 0-.46-.45h-1a.46.46 0 0 0-.45.45v5a.47.47 0 0 0 .46.46\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/supply-type.svg
// module id = ZCeR
// module chunks = 1